import { api } from '@/shared/lib/axios.ts';
import type { ProbeLogListResponse, ProbeLogListParams } from '@/shared/types/probe-log.ts';

export async function listProbeLogs(params: ProbeLogListParams): Promise<ProbeLogListResponse> {
  const { data } = await api.get<ProbeLogListResponse>('/admin/probe-logs', { params });
  return data;
}
